import React, { useEffect, useContext } from "react";
import { AppContext } from "../../store/appContext";
import "./versicherung-uber.scss";
import axios from "axios";
import { useDispatchHelpers } from "../../store/dispatchhelper";
import Banner from "../../components/banner/banner";
import WebLoader from "../../components/webLoader/WebLoader";
import { Fade } from "react-awesome-reveal";
const VersicherungUber = () => {
  const {
    state: { baseUrl, versicherung_uber, lang },
  } = useContext(AppContext);
  const { dispatchAction } = useDispatchHelpers();
  const isDataReady = Object.keys(versicherung_uber).length > 0;

  useEffect(() => {
    axios.get(`${baseUrl}versicherung-uber`).then((response) => {
      dispatchAction("setVersicherungUberData", response?.data?.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Find all span elements inside a div with class "page-container" that have style="color: white;"
    const spans = document.querySelectorAll(
      '.page-container span[style="color: white;"]'
    );
    // Add a class to each of these spans
    spans.forEach((span) => {
      span.classList.add("white-text");
    });
    // Find all span elements that have style="color: rgb(212, 185, 123);"
    const goldSpans = document.querySelectorAll(
      ' span[style="color: rgb(212, 185, 123);"]'
    );
    // Add a class to each of these spans
    goldSpans.forEach((span) => {
      span.classList.add("gold-text");
    });
  }, [versicherung_uber]);

  return (
    <React.Fragment>
      <WebLoader isLoading={!isDataReady} />
      <div className="versicherung-uber-page page">
        {versicherung_uber && isDataReady && (
          <React.Fragment>
            {
              <Banner
                mediaUrl={versicherung_uber.banners[0].path}
                title={versicherung_uber.banners[0]["title_" + lang]}
              />
            }
            <div className="page-container" id="page-container">
              <Fade triggerOnce={true} duration={1000} fraction={0.3}>
                <h2
                  className="title"
                  dangerouslySetInnerHTML={{
                    __html:
                      versicherung_uber.versicherung_uber[0]["title_" + lang],
                  }}
                />
                <img
                  src={versicherung_uber.versicherung_uber[0].image}
                  alt="versicherung-uber-image"
                />
                <p
                  className="desc"
                  dangerouslySetInnerHTML={{
                    __html:
                      versicherung_uber.versicherung_uber[0][
                        "description_" + lang
                      ],
                  }}
                />
              </Fade>
            </div>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

export default VersicherungUber;
